import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Td,
  Input,
  Select,
  FormControl,
  Link,
  VStack,
  Spinner,
  Alert,
  Flex,
  Stack,
  Button,
  Text,
  AlertIcon,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import { FaTrash } from "react-icons/fa";

import Edit_Reg_student from "./Edit_Reg_student";
import { FiMoreVertical, FiEdit, FiTrash } from "react-icons/fi";
import { BASE_URL } from "../../../Globalapi/Globalapi";
const StudentsRegister = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [events, setEvents] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const toast = useToast();
  const schoolId = sessionStorage.getItem("school_id");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // States for filtering
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");

  // Pagination logic
  const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const paginatedCategories = filteredCategories.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Fetch categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/category/list_category.php?school_id=${schoolId}`
        );
        if (response.data.success) setCategories(response.data.data || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast({
          title: "Error Fetching Categories",
          description: "An error occurred while fetching categories.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };
    fetchCategories();
  }, [schoolId]);

  // Fetch events from API
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${schoolId}`
        );
        if (response.data.success) setEvents(response.data.data.events || []);
      } catch (error) {
        console.error("Error fetching events:", error);
        toast({
          title: "Error Fetching Events",
          description: "An error occurred while fetching events.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };
    fetchEvents();
  }, [schoolId]);

  // Fetch students data
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/registration/list_reg.php`,
          {
            params: {
              school_id: sessionStorage.getItem("school_id"), // Replace with actual school ID
            },
          }
        );
        setStudents(response.data.data || []);
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  // Handle search input
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Handle event filter
  const handleEventFilter = (e) => {
    const event = e.target.value;
    setSelectedEvent(event);

    // Filter categories based on the selected event
    const categoriesForEvent = categories.filter(
      (category) => category.event_title === event
    );
    setFilteredCategories(categoriesForEvent);

    // Clear category and sub-category selections
    setSelectedCategory("");
    setSelectedSubCategory("");
  };

  // Handle category filter
  const handleCategoryFilter = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    console.log("filter subcatgry list", category);
    // Filter sub-categories based on the selected category
    const subCategoriesForCategory = students
      .filter((student) => student.category === category)
      .map((student) => student.sub_category);
    setFilteredSubCategories(Array.from(new Set(subCategoriesForCategory)));
    setSelectedSubCategory(""); // Reset sub-category when category changes
  };

  // Handle sub-category filter
  const handleSubCategoryFilter = (e) => {
    setSelectedSubCategory(e.target.value);
  };

  // Filter students based on search term, event, category, and sub-category
  const filteredStudents = students.filter((student) => {
    const isMatchingName = student.student_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const isMatchingEvent =
      selectedEvent === "" || student.event_title === selectedEvent;
    const isMatchingCategory =
      selectedCategory === "" || student.category === selectedCategory;
    const isMatchingSubCategory =
      selectedSubCategory === "" ||
      student.sub_category === selectedSubCategory;

    return (
      isMatchingName &&
      isMatchingEvent &&
      isMatchingCategory &&
      isMatchingSubCategory
    );
  });

  // Delete student handler
  const handleDelete = async (regId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/events/registration/delete_reg.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            reg_id: regId,
            school_id: schoolId,
            user_id: sessionStorage.getItem("user_id"),
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        toast({
          title: "Deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Remove the deleted record from the state
        setStudents((prevEvents) =>
          prevEvents.filter((event) => event.id !== regId)
        );
      } else {
        toast({
          title: "Failed to delete.",
          description: result.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      toast({
        title: "Error occurred.",
        description: "Unable to delete record.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (loading) {
    return (
      <Box textAlign="center" py={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert status="error">
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return (
    <Box>
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Student Register</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              {/* <Main_Category />
              <Sub_Cat_form /> */}
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Event </span> /
          <Link
            // to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Student Register</span>
          </Link>
        </Box>
      </div>
      <Box
        p={4}
        ml={{ base: 0, md: 5 }} // Remove left margin on small screens
      >
        <Flex
          direction={{ base: "column", md: "row" }} // Stack vertically on small screens, horizontally on larger screens
          justify="flex-end"
          align="center"
          // mb={1}
          p={3}
          className="sb"
        >
          {/* Search and Filters */}
          <Box
            // display="flex"
            // flexWrap={{ base: "wrap", md: "nowrap" }} // Wrap on small screens, no wrap on larger
            // justifyContent="flex-end"
            // gap={4}
            // width="100%"
            display="flex"
            flexWrap={{ base: "wrap", md: "nowrap" }}
            justifyContent={{ base: "flex-start", md: "space-between" }}
            alignItems="center"
            gap={4}
            width="100%"
            // p={3}
            // className="sb"
          >
            {/* <Stack direction="row" spacing={4} mb={{ base: 4, md: 0 }}>
              {" "}
              <Flex align="center">
                <Select
                  width={{ base: "380px", sm: "100px" }} // Full width on small screens, fixed width on larger
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  borderColor="#E9EDF4"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Select>
              </Flex>
            </Stack> */}

            <FormControl width={{ base: "100px", sm: "100px" }}>
              <Select
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                borderColor="#E9EDF4"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </Select>
            </FormControl>

            <Box
              display="flex"
              flexWrap={{ base: "wrap", md: "nowrap" }}
              // justifyContent={{ base: "flex-start", md: "flex-end" }} 
              alignItems="center"
              gap={4}
              mt={{ base: 4, md: 0 }} 
              width={{ base: "100%", md: "auto" }} 
            >
              {/* Search Bar */}
              <FormControl width={{ base: "100%", sm: "250px" }}>
                {" "}
                {/* Full width on mobile, fixed width on larger */}
                <Input
                  placeholder="Search by name"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </FormControl>

              {/* Event Filter */}
              <FormControl width={{ base: "100%", sm: "250px" }}>
                {" "}
                {/* Full width on mobile, fixed width on larger */}
                <Select
                  placeholder="Select Event"
                  value={selectedEvent}
                  onChange={handleEventFilter}
                >
                  {events.map((event) => (
                    <option key={event.id} value={event.title}>
                      {event.event_title}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* Category Filter */}
              <FormControl
                width={{ base: "100%", sm: "250px" }}
                isDisabled={!selectedEvent}
              >
                <Select
                  placeholder="Select Category"
                  value={selectedCategory}
                  onChange={handleCategoryFilter}
                >
                  {filteredCategories.map((category) => (
                    <option key={category.id} value={category.name}>
                      {category.category}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* Sub-Category Filter */}
              <FormControl
                width={{ base: "100%", sm: "250px" }}
                isDisabled={!selectedCategory}
              >
                <Select
                  placeholder="Select Sub-Category"
                  value={selectedSubCategory}
                  onChange={handleSubCategoryFilter}
                >
                  {filteredSubCategories.map((subCategory) => (
                    <option key={subCategory} value={subCategory}>
                      {subCategory}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Flex>

        <VStack
          spacing={4}
          align="stretch"
          // ml={5}
          overflowX="auto"
          maxWidth="100%"
        >
          {/* Students Table */}
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
          >
            <Thead>
              <Tr>
                <Th>Student Name</Th>
                <Th>Event</Th>
                <Th>Category</Th>
                <Th>Sub-Category</Th>
                <Th>Allocated Teacher</Th>
                <Th>Class</Th>
                <Th>Division</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredStudents.map((student) => (
                <Tr key={student.id}>
                  <Td>{student.student_name}</Td>
                  <Td>{student.event_title}</Td>
                  <Td>{student.category}</Td>
                  <Td>{student.sub_category}</Td>
                  <Td>{student.staff_name}</Td>
                  <Td>{student.class}</Td>
                  <Td>{student.division}</Td>
                  <Td>
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<FiMoreVertical />}
                        variant="outline"
                      />
                      <MenuList
                        width="auto" // Automatically adjusts width to fit content
                        sx={{ padding: "8px" }} // Optional: Adjust padding for compactness
                      >
                        {/* Edit Button */}
                        <Edit_Reg_student reg_id={student.id} />

                        {/* Delete Button */}
                        <MenuItem
                          size="sm"
                          onClick={() => handleDelete(student.id)}
                        >
                          <FaTrash
                            style={{ marginRight: "8px", color: "red" }}
                          />{" "}
                          {/* Red color for the icon */}
                          Delete
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </VStack>

        <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" mx={2}>
            {currentPage > 1 && (
              <>
                <Button onClick={() => handlePageChange(1)}>1</Button>
                {currentPage > 2 && <Text>...</Text>}
              </>
            )}
            <Button backgroundColor="teal" color="white">
              {currentPage}
            </Button>
            {currentPage < totalPages - 1 && (
              <>
                <Text>...</Text>
                <Button onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Button>
              </>
            )}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default StudentsRegister;
